import React from "react";

export const Marquee = ({ text = "THE HOODIE PROJECT", accent = "®" }) => {
  const chunk = Array.from({ length: 8 });
  return (
    <div className="overflow-hidden border-y border-border bg-white py-4 text-black" data-testid="marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((g) => (
          <div key={g} className="flex">
            {chunk.map((_, i) => (
              <span key={i} className="mx-6 font-display text-2xl font-extrabold tracking-tighter md:text-3xl">
                {text}<span className="align-super text-sm">{accent}</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
